module.exports = __webpack_public_path__ + "static/media/letterKnowledge-intro.bd3f992f.mp3";